<template>
    <div>
        <h3>
            L'export Excel contient les colonnes suivantes
        </h3>

        <ul class="mb-4">
            <li><strong>An</strong> : Année</li>
            <li><strong>Client</strong></li>
            <li><strong>Cabinet</strong> : Cabinet du client</li>
            <li><strong>Compte comptable</strong> : Affectation</li>
            <li><strong>Facturé</strong> : Montant facturé</li>
            <li><strong>Coût</strong> : Coût réel</li>
        </ul>
        <b-alert show variant="primary">
            Les données ne concernent que l'année sélectionnée et respectent les filtres du panneau gauche. Seuls les montants concernant les affectations utilisées pour la marge sont exportés.
        </b-alert>
        <b-button
            :href="exportUrl"
            variant="success"
            class="mt-2"
        >
            <i class="fas fa-file-excel mr-2"></i>Télécharger l'export Excel
        </b-button>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'DashboardBilledVsRealExport',

    computed: {
        ...mapState({
            year: (state) => state.browsing.year,
            menuRoutes: (state) => state.dashboardVM.menuRoutes,
        }),

        exportUrl() {
            const base = this.menuRoutes['billed-vs-real-export'] || ''
            return base ? `${base}/${this.year}` : '#'
        },
    },

    mounted() {
        this.$store.commit('browsing/SET_PAGE_NAME', 'billed-vs-real-export')
    },
}
</script>
